module.exports = __webpack_public_path__ + "img/call.344d6704.svg";